module.exports = __webpack_public_path__ + "static/media/medium_tan.507b1a04.jpg";